/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Measure_RequestsInputs */

const en_measure_requests = /** @type {(inputs: Measure_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requests`)
};

const zh_hans1_measure_requests = /** @type {(inputs: Measure_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请求数`)
};

const pt_br2_measure_requests = /** @type {(inputs: Measure_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requisições`)
};

const es_measure_requests = /** @type {(inputs: Measure_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solicitudes`)
};

const fr_measure_requests = /** @type {(inputs: Measure_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requêtes`)
};

const de_measure_requests = /** @type {(inputs: Measure_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anfragen`)
};

const ru_measure_requests = /** @type {(inputs: Measure_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запросы`)
};

const it_measure_requests = /** @type {(inputs: Measure_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Richieste`)
};

/**
* | output |
* | --- |
* | "Requests" |
*
* @param {Measure_RequestsInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_requests = /** @type {((inputs?: Measure_RequestsInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Measure_RequestsInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_measure_requests(inputs)
	if (locale === "pt-BR") return pt_br2_measure_requests(inputs)
	if (locale === "es") return es_measure_requests(inputs)
	if (locale === "fr") return fr_measure_requests(inputs)
	if (locale === "de") return de_measure_requests(inputs)
	if (locale === "ru") return ru_measure_requests(inputs)
	if (locale === "it") return it_measure_requests(inputs)
	return en_measure_requests(inputs)
});